<div class="row justify-content-center login-page">
    <div fxLayoutAlign="center center" fxFlexFill class="main-div">
        <form [formGroup]="loginForm" (submit)="submitLoginForm()">
            <mat-card fxFlex="25" class="login-container">
                <div fxLayoutAlign="stretch" fxLayout="column" class="login-form">
                    <div class="logo-container">
                        <img src="assets/logo.svg" alt="Logo" class="logo-icon">
                    </div>
                    <div class="parking-title">
                        <h5>Parcări Oradea<br><span>Admin area</span></h5>
                    </div>
                    <mat-form-field appearance="outline">
                        <input matInput class="custom-input" type="email" placeholder="Introduceți adresa de e-mail"
                            formControlName="email">
                        <mat-error *ngIf="email?.errors?.['required']">Email is required</mat-error>
                        <mat-error *ngIf="email?.errors?.['email']">
                            Please enter a correct email format
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="input-field">
                        <input matInput [type]="changeType ? 'password' : 'text'" class="custom-input"
                            placeholder="Introduceți parola" formControlName="password">
                        <mat-error *ngIf="password?.errors?.['required']">
                            Password is required
                        </mat-error>
                        <button type="button" class="hide-btn" (click)="viewPassword()">
                            <i class="eye-icon" [ngClass]="visibile ? 'bi bi-eye' : 'bi bi-eye-slash'"></i>
                        </button>
                    </mat-form-field>
                    <button class="login-button" type="submit">Login</button>
                </div>
            </mat-card>
        </form>
    </div>
</div>